export default __webpack_public_path__ + "static/gw2-icon-combat-5f6a2aba2c436827a8f71a5e5a016643.png";